"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.businessFetchByIdReducer = exports.businessFetchAllReducer = exports.businessUpdateReducer = exports.businessCreateReducer = exports.businessFetchReducer = exports.businessFetchByIdSlice = exports.businessFetchAllSlice = exports.businessUpdateSlice = exports.businessCreateSlice = exports.businessFetchSlice = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const businessAction_1 = require("./businessAction");
const fetchInitialState = {
    loading: false,
    error: null,
    data: []
};
const createInitialState = {
    loading: false,
    error: null,
    data: []
};
const updateInitialState = {
    loading: false,
    error: null,
    data: []
};
const fetchAllBusinessInitialState = {
    loading: false,
    error: null,
    data: []
};
const fetchByIdInitialState = {
    loading: false,
    error: null,
    data: []
};
exports.businessFetchSlice = (0, toolkit_1.createSlice)({
    name: 'business/fetch',
    initialState: fetchInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(businessAction_1.fetch.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(businessAction_1.fetch.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(businessAction_1.fetch.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.businessCreateSlice = (0, toolkit_1.createSlice)({
    name: 'business/create',
    initialState: createInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(businessAction_1.create.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(businessAction_1.create.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(businessAction_1.create.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.businessUpdateSlice = (0, toolkit_1.createSlice)({
    name: 'business/update',
    initialState: updateInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(businessAction_1.update.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(businessAction_1.update.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(businessAction_1.update.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.businessFetchAllSlice = (0, toolkit_1.createSlice)({
    name: 'business/fetchAllBusiness',
    initialState: fetchAllBusinessInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(businessAction_1.fetchAllBusiness.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(businessAction_1.fetchAllBusiness.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(businessAction_1.fetchAllBusiness.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.businessFetchByIdSlice = (0, toolkit_1.createSlice)({
    name: 'business/fetchBusinessById',
    initialState: fetchByIdInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(businessAction_1.fetchBusinessById.pending, (state) => {
            state.loading = true;
            state.error = null;
            state.data = [];
        })
            .addCase(businessAction_1.fetchBusinessById.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.data = action.payload;
        })
            .addCase(businessAction_1.fetchBusinessById.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
            state.data = [];
        });
    }
});
exports.businessFetchReducer = exports.businessFetchSlice.reducer;
exports.businessCreateReducer = exports.businessCreateSlice.reducer;
exports.businessUpdateReducer = exports.businessUpdateSlice.reducer;
exports.businessFetchAllReducer = exports.businessFetchAllSlice.reducer;
exports.businessFetchByIdReducer = exports.businessFetchByIdSlice.reducer;
